import React from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import VSKHome from "../components/VSKHome";

import Certifications from "../components/Certifications";

export default function VHome() {
  return (
    <>
      <Navibar />

      <VSKHome />

      <Certifications />
      <Footer />
     
    </>
  );
}
